import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { confirmPasswordReset } from '../../../services/authService';

const ResetPasswordPage = () => {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (newPassword1 !== newPassword2) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await confirmPasswordReset(uidb64, token, newPassword1, newPassword2);
      setMessage('Password reset successfully. Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>
        <form onSubmit={handleSubmit}>
          <label className="block mb-2 text-gray-700">New Password</label>
          <input
            type="password"
            className="w-full px-3 py-2 border rounded mb-4"
            value={newPassword1}
            onChange={e => setNewPassword1(e.target.value)}
            required
          />
          <label className="block mb-2 text-gray-700">Confirm New Password</label>
          <input
            type="password"
            className="w-full px-3 py-2 border rounded mb-4"
            value={newPassword2}
            onChange={e => setNewPassword2(e.target.value)}
            required
          />
          {message && <div className="mb-4 text-green-600 text-sm">{message}</div>}
          {error && <div className="mb-4 text-red-600 text-sm">{error}</div>}
          <button
            type="submit"
            className="w-full bg-primary-600 text-white py-2 rounded hover:bg-primary-700 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
        <div className="mt-6 text-center">
          <Link to="/login" className="text-primary-600 hover:underline">Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
